import { InjectionToken } from "@angular/core";
import { IOnboardingService } from "./onboarding-service.interface";

export const ONBOARDING_SERVICE = new InjectionToken<IOnboardingService>(
  'ONBOARDING_SERVICE'
);
